<template>
	<div class="model_mid">
		<div class="mid_left">
			<h3>果实成熟期内环境监测及水肥灌溉情况</h3>
			<div class="mid_left_table_title">
				<div class="title_item" :class="{ title_item_active: activeIndex === 0 }" @click="addActive(0)">
					气象监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 1 }" @click="addActive(1)">
					土壤监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 2 }" @click="addActive(2)">
					水肥灌溉记录
				</div>
			</div>
			<wearth v-if="activeIndex===0" />
			<roil v-if="activeIndex===1" />
		    <fertilizer v-if="activeIndex===2"/>
		</div>
		<div class="mid_img">
			<img src="@/assets/period/7.png" alt="" />
		</div>
		<div class="mid_right">
			<div class="back_title"></div>
			<div class="agricultural_boder">
				<div class="agricultural">
					农事提醒：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						果穗达到该品种应有的色泽、风味，宜适时采收。采下的果穗要整形，剪除小粒、病虫果、腐烂果，</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-8-21
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="divider"></div>
			</div>
			<div class="control">
				<p>
					<sapn class="diseases">主要病虫害:</sapn>
					<sapn class="diseases_text">
						霜霉病、炭疽病、白腐病、黑痘病、灰霉病、食心虫、金龟子等
					</sapn>
				</p>
				<p>
					<span class="Prevention">防治措施:</span>
					<span
						class="Prevention_text">
					  喷波尔多液1∶0.5～0.7∶160～200倍液，并与50%抑霉唑3 000 倍液+25%嘧菌酯1 000倍液+2.5%联苯菊酯1 500 倍液交替；或喷波尔多液1∶0.5～0.7∶160～200 倍液，并与25%嘧菌酯1 000倍液+2.5%联苯菊酯1 500 倍液交替（炭疽病不严重）；田间挂糖醋液诱杀白星花金龟子。
					</span>
				</p>
		
			</div>
		
		</div>
		
	</div>
	
	<div class="model_content">
		<div class="model_content_title">果实成熟期</div>
		<div class="model_content_date">08-21 至 09-10</div>
		<div class="model_content_text">
			在果实成熟期，阳光玫瑰葡萄达到采摘标准，果实糖分充足，风味最佳。这时需进行适时采收，确保果实在最佳状态下进入市场。
		</div>
	</div>
	
</template>

<script setup>
	import {
		ref
	} from 'vue';
	import wearth from './wearth/index.vue';
	import roil from './roil/index.vue';
	import fertilizer from './fertilizer/index.vue';

	let activeIndex = ref(0);

	function addActive(e) {
		activeIndex.value = e;
	}
</script>

<style lang="scss" scoped>
	.model_mid {
		width: 1840px;
		margin: 0 auto;
		height: 660px;
		background-image: url('../../../assets/model/mid-boder.png');
		background-size: 100% 100%;
		margin-top: 100px;
		display: flex;
		.mid_left {
				width: 660px;
				height: 540px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/mid-left.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				h3 {
					margin-left: 40px;
					color: #2dffd0;
				}
		
				.mid_left_table_title {
					width: 60%;
					display: flex;
					font-size: 14px;
					margin: 0 auto;
					margin-top: 20px;
					justify-content: space-between;
					color: #00a580;
		
					.title_item {
						flex: 1;
						text-align: center;
						padding: 5px;
					}
		
					.title_item_active {
						background-image: url('@/assets/model/mid-left-button.png');
						color: white;
						background-size: 100% 100%;
					}
				}
		
		
		
			}
		
			.mid_img {
				margin-left: 30px;
				margin-top: 200px;
			}
		
			.mid_right {
				padding: 20px;
				width: 660px;
				height: 350px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/smallboder.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				.back_title {
					height: 28px;
					width: 620px;
					background-image: url("@/assets/model/smalltitle.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
		
				.agricultural_boder {
					font-size: 12px;
					.agricultural {
						color: #72a39f;
						margin-top: 20px;
						margin-left: 15px;
					}
		
					.agricultural_tcontent {
						width: 620px;
						display: flex;
						color: #007e62;
						margin-top: 10px;
						align-items: center;
						/* 垂直居中 */
						justify-content: space-between;
						/* 水平两端对齐 */
						padding-left: 15px;
		
						.agricultural_tcontent_left {
							text-align: justify;
							width: 350px;
						}
		
					}
		
					.divider {
						height: 2px;
						width: 100%;
						margin-top: 20px;
						background: linear-gradient(to right, transparent, #00796B, transparent);
					}
				}
		
				.control {
					color: white;
					margin-top: 20px;
					width: 100%;
					padding-left: 15px;
					text-align: justify;
					font-size: 14px;
		
		
					p {
						display: flex;
						justify-content: flex-start;
						padding-top: 15px;
					}
		
					.diseases {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
		
					}
		
					.diseases_text {
						display: inline-block;
						width: 520px;
						line-height: 20px;
						color: #007e62;
						padding-left: 20px;
					}
		
					.Prevention {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
					}
		
					.Prevention_text {
						display: inline-block;
						width: 520px;
						color: #007e62;
						line-height: 20px;
						padding-left: 20px;
					}
		
		
		
				}
		
			}

	}
	
	.model_content {
		width: 685px;
		height: 100px;
		margin: 0px auto;
		text-align: center;
		color: white;
		margin-top: -60px;
	
		.model_content_title {
			color: #23c9a4;
			font-size: 18px;
			font-weight: bold;
		}
	
		.model_content_date {
			margin-top: 10px;
			color: white;
			font-size: 16px;
			color: #23c9a4;
			font-weight: bold;
		}
	
		.model_content_text {
			margin-top: 10px;
			color: #23c9a4;
		}
	}
	
	
</style>